import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';
import { PartFieldOperator } from 'corporate/enums';

export const upsertPricingProfileRuleSchema = () =>
  yup.object().shape({
    manufacturer: yup.object().nullable(),
    category: yup.object().nullable(),
    partFieldCriteria: yup.array().of(partFieldCriteriaSchema),
    companyPartFieldCriteria: yup.array().of(companyPartFieldCriteriaSchema),
    value: numberSchemaWithTransform()
      .label(t('labelValue'))
      .required(getEmptyErrorMessage(t('labelValue'))),
  });

export const partFieldCriteriaSchema = yup.object().shape({
  partField: yup
    .object()
    .label(t('labelPartField'))
    .nullable()
    .required(getEmptyErrorMessage(t('labelPartField'))),
  operator: yup
    .mixed<PartFieldOperator>()
    .oneOf(Object.values(PartFieldOperator))
    .label(t('labelOperation'))
    .required(getEmptyErrorMessage(t('labelOperation'))),
  value: yup
    .string()
    .label(t('labelValue'))
    .required(getEmptyErrorMessage(t('labelValue'))),
  uom: yup.object().nullable(),
});

export const companyPartFieldCriteriaSchema = yup.object().shape({
  companyPartField: yup
    .object()
    .label(t('labelPartField'))
    .nullable()
    .required(getEmptyErrorMessage(t('labelPartField'))),
  operator: yup
    .mixed<PartFieldOperator>()
    .oneOf(Object.values(PartFieldOperator))
    .label(t('labelOperation'))
    .required(getEmptyErrorMessage(t('labelOperation'))),
  value: yup
    .string()
    .label(t('labelValue'))
    .required(getEmptyErrorMessage(t('labelValue'))),
});
